import PointAndClick from './PointAndClick.js';

import ButtonDecor from '../../prefabs/global/pointandclick/ButtonDecor.js';
import { Colors } from '../../consts/Colors.js';
import PopUpDecor from '../../prefabs/global/pointandclick/PopUpDecor.js';


export default class Chapitre6 extends PointAndClick {
    constructor() {
        super({
            key: "Chapitre6"
        })
    }

    init(data){
        this.audioName = 'HourlyInterlapse';
        super.init(data);   
    }

    create(){
        super.create();
        this.animIn(() => {this.displayButtons();} );        


    }

    // -- Popups spécifiques --
    openIndiceSpecial(id, data){
        if(data.type == "leila"){
            this.openIndice(id, data)
            this.soundManager.playOnce('Leila')
            this.popup.closeButton.setVisible(false);
            this.unblurBackground();
            this.addRoueBouton()
        }
    }

    addRoueBouton(){
        let data = this.config.roue
        this.config.boutons.push(data)

        let button = new ButtonDecor(this, data.position.x, data.position.y, 1)
        button.setAlpha(0)
        if(this.chapitreProgression.boutonsDecors[1] == 1){
            button.setViewed();
        }

        this.buttons.push(button)

        button.setClickFunction( (btnInstance) => {
            if(!btnInstance.isViewed){
                btnInstance.setViewed();
                this.chapitreProgression.boutonsDecors[btnInstance.id] = 1;
                this.sauvegardeManager.updateProgression(this.scene.key, this.chapitreProgression);
            }

            this.addRoueAnimation()

        } )

        this.tweens.add({
            targets: button,
            alpha: 1,
            delay: 500,
            duration: 500,
        })
    }

    addRoueAnimation(){
        let roueImage1 = this.add.image(1576, 658 + 50, 'decor_roue').setOrigin(0.5)
        roueImage1.depth = 501
        roueImage1.setAlpha(0)

        this.soundManager.playOnce('RoueTourne')
        this.tweens.add({
            targets: roueImage1,
            y: 658,
            alpha: 1,
            duration: 500,
            onComplete: () => {

                let roueImage2 = this.add.image(473, 540 -50, 'decor_boom').setOrigin(0.5)
                roueImage2.depth = 501
                roueImage2.setAlpha(0)
                this.tweens.add({
                    targets: roueImage2,
                    y: 540,
                    alpha: 1,
                    delay: 300,
                    duration: 500,
                    onStart: () => {
                        this.cameras.main.shake(500, 0.01)
                        this.soundManager.playOnce('GardeTombe')
                    },
                    onComplete: () => {
                        this.openPopUpFin()
                    }
                })
            }
        })

    }

    openPopUpFin(){
        let data = this.config.fin

        this.rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        this.rect.depth = 1000
        this.rect.setAlpha(0)
        
        this.popup = new PopUpDecor(this, data.poupPosition.x, data.poupPosition.y, {
            imageKey: data.imageKey,
            description: data.description,
            textPosition: data.textPosition,
            textColor: Colors.Text[data.textColor],
            boutonText: "Terminer le jeu !",
            endFunction: () => {this.animOut()}
        })
        // this.popup.textElmt.setStyle({
        //     align: 'left',
        // })
        this.popup.depth = 1002;
        this.popup.setAlpha(0)

        this.time.addEvent({
            delay: 500,
            callback: () => {
                // this.soundManager.playOnce('GoodEnding')

                this.popup.animIn()
                this.tweens.add({
                    targets: this.rect,
                    alpha: 0.5,
                    duration: 500,
                })
            }
        })
    }


    animOut(){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.setAlpha(0)
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 1,
            duration: 1000,
            onComplete: () => {
                this.scene.start("Fin")
            }
        })
    }

    animIn(endFunction){
        let rect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.Black).setOrigin(0);
        rect.depth = 1002
        this.tweens.add({
            targets: rect,
            alpha: 0,
            duration: 1000,
            onComplete: () => {
                if(endFunction){
                    endFunction();
                }
            }
        })
    }

}